var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGplayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 60,
    viewBox: "0 0 202 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 201,
    height: 59,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 201,
    height: 59,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.952 32.6267C98.4324 32.6267 95.5639 35.3102 95.5639 39.0062C95.5639 42.6797 98.4324 45.3857 101.952 45.3857C105.472 45.3857 108.341 42.6797 108.341 39.0062C108.339 35.3102 105.471 32.6267 101.952 32.6267ZM101.952 42.8747C100.023 42.8747 98.3605 41.2802 98.3605 39.0077C98.3605 36.7112 100.024 35.1407 101.952 35.1407C103.88 35.1407 105.543 36.7112 105.543 39.0077C105.543 41.2787 103.88 42.8747 101.952 42.8747ZM88.0151 32.6267C84.4958 32.6267 81.6274 35.3102 81.6274 39.0062C81.6274 42.6797 84.4958 45.3857 88.0151 45.3857C91.5359 45.3857 94.4043 42.6797 94.4043 39.0062C94.4043 35.3102 91.5359 32.6267 88.0151 32.6267ZM88.0151 42.8747C86.0864 42.8747 84.424 41.2802 84.424 39.0077C84.424 36.7112 86.0879 35.1407 88.0151 35.1407C89.9439 35.1407 91.6062 36.7112 91.6062 39.0077C91.6077 41.2787 89.9439 42.8747 88.0151 42.8747ZM71.4392 34.5857V37.2917H77.9002C77.7071 38.8142 77.2014 39.9257 76.4293 40.6982C75.4896 41.6402 74.0188 42.6797 71.4392 42.6797C67.462 42.6797 64.3527 39.4652 64.3527 35.4782C64.3527 31.4912 67.462 28.2767 71.4392 28.2767C73.5848 28.2767 75.1515 29.1227 76.3081 30.2102L78.2129 28.3007C76.5969 26.7542 74.4527 25.5707 71.4392 25.5707C65.9911 25.5707 61.411 30.0167 61.411 35.4782C61.411 40.9397 65.9911 45.3857 71.4392 45.3857C74.3794 45.3857 76.5984 44.4182 78.3326 42.6062C80.1162 40.8182 80.6713 38.3042 80.6713 36.2747C80.6713 35.6477 80.6234 35.0672 80.5262 34.5842H71.4392V34.5857ZM139.233 36.6872C138.704 35.2622 137.088 32.6267 133.785 32.6267C130.507 32.6267 127.782 35.2127 127.782 39.0062C127.782 42.5822 130.483 45.3857 134.098 45.3857C137.014 45.3857 138.702 43.5977 139.402 42.5582L137.233 41.1077C136.51 42.1712 135.521 42.8717 134.098 42.8717C132.677 42.8717 131.664 42.2192 131.013 40.9382L139.522 37.4102L139.233 36.6872ZM130.555 38.8142C130.483 36.3482 132.46 35.0927 133.883 35.0927C134.991 35.0927 135.931 35.6492 136.245 36.4457L130.555 38.8142ZM123.637 45.0002H126.433V26.2487H123.637V45.0002ZM119.056 34.0532H118.96C118.333 33.3032 117.127 32.6267 115.61 32.6267C112.427 32.6267 109.511 35.4302 109.511 39.0317C109.511 42.6077 112.427 45.3872 115.61 45.3872C117.129 45.3872 118.333 44.7107 118.96 43.9382H119.056V44.8562C119.056 47.2967 117.754 48.6017 115.658 48.6017C113.946 48.6017 112.885 47.3702 112.451 46.3307L110.017 47.3462C110.715 49.0367 112.571 51.1157 115.658 51.1157C118.936 51.1157 121.709 49.1822 121.709 44.4692V33.0152H119.057V34.0532H119.056ZM115.851 42.8747C113.922 42.8747 112.308 41.2547 112.308 39.0317C112.308 36.7832 113.922 35.1407 115.851 35.1407C117.754 35.1407 119.249 36.7832 119.249 39.0317C119.249 41.2547 117.754 42.8747 115.851 42.8747ZM152.332 26.2487H145.642V45.0002H148.433V37.8962H152.33C155.425 37.8962 158.468 35.6507 158.468 32.0732C158.468 28.4957 155.426 26.2487 152.332 26.2487ZM152.404 35.2862H148.433V28.8587H152.404C154.491 28.8587 155.676 30.5912 155.676 32.0732C155.676 33.5252 154.491 35.2862 152.404 35.2862ZM169.659 32.5937C167.638 32.5937 165.544 33.4862 164.678 35.4647L167.156 36.5012C167.685 35.4647 168.673 35.1257 169.707 35.1257C171.151 35.1257 172.619 35.9942 172.643 37.5377V37.7312C172.137 37.4417 171.054 37.0082 169.731 37.0082C167.06 37.0082 164.34 38.4797 164.34 41.2292C164.34 43.7387 166.53 45.3542 168.984 45.3542C170.861 45.3542 171.896 44.5097 172.545 43.5197H172.641V44.9672H175.337V37.7777C175.339 34.4507 172.858 32.5937 169.659 32.5937ZM169.321 42.8702C168.408 42.8702 167.132 42.4112 167.132 41.2772C167.132 39.8297 168.721 39.2747 170.093 39.2747C171.318 39.2747 171.898 39.5402 172.643 39.9017C172.426 41.6402 170.934 42.8702 169.321 42.8702ZM185.156 33.0032L181.956 41.1332H181.86L178.538 33.0032H175.531L180.512 44.3657L177.672 50.6867H180.584L188.261 33.0032H185.156ZM160.009 45.0002H162.8V26.2487H160.009V45.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9515 15.3644C70.9515 16.6214 70.5804 17.6219 69.8367 18.3689C68.9928 19.2569 67.8915 19.7009 66.5389 19.7009C65.2431 19.7009 64.1403 19.2509 63.2351 18.3509C62.3283 17.4494 61.8749 16.3334 61.8749 15.0014C61.8749 13.6679 62.3283 12.5519 63.2351 11.6519C64.1403 10.7504 65.2431 10.3004 66.5389 10.3004C67.1823 10.3004 67.7973 10.4264 68.3808 10.6769C68.9659 10.9289 69.4342 11.2634 69.7843 11.6819L68.9958 12.4739C68.4018 11.7614 67.5833 11.4059 66.5374 11.4059C65.5917 11.4059 64.7747 11.7389 64.0849 12.4049C63.3952 13.0709 63.051 13.9364 63.051 14.9999C63.051 16.0634 63.3952 16.9289 64.0849 17.5949C64.7747 18.2609 65.5917 18.5939 66.5374 18.5939C67.5399 18.5939 68.3763 18.2594 69.0452 17.5889C69.4791 17.1524 69.7305 16.5449 69.7978 15.7664H66.5374V14.6849H70.8871C70.932 14.9204 70.9515 15.1469 70.9515 15.3644Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8495 11.6055H73.7616V14.4585H77.4485V15.54H73.7616V18.393H77.8495V19.5H72.608V10.5H77.8495V11.6055Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7138 19.5H81.5602V11.6055H79.0524V10.5H85.2216V11.6055H82.7138V19.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.685 19.5V10.5H90.8386V19.5H89.685Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9547 19.5H94.8011V11.6055H92.2933V10.5H98.4625V11.6055H95.9547V19.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.141 18.3375C109.258 19.2465 108.161 19.701 106.849 19.701C105.537 19.701 104.44 19.2465 103.559 18.3375C102.676 17.4285 102.236 16.3155 102.236 15C102.236 13.6845 102.676 12.5715 103.559 11.6625C104.44 10.7535 105.537 10.2975 106.849 10.2975C108.154 10.2975 109.249 10.755 110.135 11.6685C111.021 12.582 111.463 13.692 111.463 15C111.463 16.3155 111.022 17.4285 110.141 18.3375ZM104.41 17.583C105.074 18.258 105.887 18.594 106.849 18.594C107.811 18.594 108.625 18.2565 109.288 17.583C109.952 16.908 110.286 16.047 110.286 15C110.286 13.953 109.952 13.092 109.288 12.417C108.625 11.742 107.811 11.406 106.849 11.406C105.887 11.406 105.074 11.7435 104.41 12.417C103.747 13.092 103.413 13.953 103.413 15C103.413 16.047 103.747 16.908 104.41 17.583Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.083 19.5V10.5H114.486L118.849 17.5005H118.899L118.849 15.7665V10.5H120.003V19.5H118.798L114.233 12.159H114.184L114.233 13.893V19.5H113.083Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9515 15.3644C70.9515 16.6214 70.5804 17.6219 69.8367 18.3689C68.9928 19.2569 67.8915 19.7009 66.5389 19.7009C65.2431 19.7009 64.1403 19.2509 63.2351 18.3509C62.3283 17.4494 61.8749 16.3334 61.8749 15.0014C61.8749 13.6679 62.3283 12.5519 63.2351 11.6519C64.1403 10.7504 65.2431 10.3004 66.5389 10.3004C67.1823 10.3004 67.7973 10.4264 68.3808 10.6769C68.9659 10.9289 69.4342 11.2634 69.7843 11.6819L68.9958 12.4739C68.4018 11.7614 67.5833 11.4059 66.5374 11.4059C65.5917 11.4059 64.7747 11.7389 64.0849 12.4049C63.3952 13.0709 63.051 13.9364 63.051 14.9999C63.051 16.0634 63.3952 16.9289 64.0849 17.5949C64.7747 18.2609 65.5917 18.5939 66.5374 18.5939C67.5399 18.5939 68.3763 18.2594 69.0452 17.5889C69.4791 17.1524 69.7305 16.5449 69.7978 15.7664H66.5374V14.6849H70.8871C70.932 14.9204 70.9515 15.1469 70.9515 15.3644Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8495 11.6055H73.7616V14.4585H77.4485V15.54H73.7616V18.393H77.8495V19.5H72.608V10.5H77.8495V11.6055Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7138 19.5H81.5602V11.6055H79.0524V10.5H85.2216V11.6055H82.7138V19.5Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.685 19.5V10.5H90.8386V19.5H89.685Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9547 19.5H94.8011V11.6055H92.2933V10.5H98.4625V11.6055H95.9547V19.5Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.141 18.3375C109.258 19.2465 108.161 19.701 106.849 19.701C105.537 19.701 104.44 19.2465 103.559 18.3375C102.676 17.4285 102.236 16.3155 102.236 15C102.236 13.6845 102.676 12.5715 103.559 11.6625C104.44 10.7535 105.537 10.2975 106.849 10.2975C108.154 10.2975 109.249 10.755 110.135 11.6685C111.021 12.582 111.463 13.692 111.463 15C111.463 16.3155 111.022 17.4285 110.141 18.3375ZM104.41 17.583C105.074 18.258 105.887 18.594 106.849 18.594C107.811 18.594 108.625 18.2565 109.288 17.583C109.952 16.908 110.286 16.047 110.286 15C110.286 13.953 109.952 13.092 109.288 12.417C108.625 11.742 107.811 11.406 106.849 11.406C105.887 11.406 105.074 11.7435 104.41 12.417C103.747 13.092 103.413 13.953 103.413 15C103.413 16.047 103.747 16.908 104.41 17.583Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.083 19.5V10.5H114.486L118.849 17.5005H118.899L118.849 15.7665V10.5H120.003V19.5H118.798L114.233 12.159H114.184L114.233 13.893V19.5H113.083Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6153 11.3069C15.1799 11.7689 14.9226 12.4859 14.9226 13.4144V46.5884C14.9226 47.5184 15.1799 48.2339 15.6153 48.6959L15.7261 48.8039L34.2637 30.2204V30.0014V29.7824L15.7261 11.1974L15.6153 11.3069Z",
    fill: "url(#paint0_linear_2_163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4419 36.417L34.2637 30.2205V30.0015V29.7825L40.4434 23.5875L40.5825 23.667L47.9039 27.837C49.9942 29.028 49.9942 30.9765 47.9039 32.169L40.5825 36.339L40.4419 36.417Z",
    fill: "url(#paint1_linear_2_163)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5825 36.3375L34.2622 30.0015L15.6153 48.696C16.3036 49.428 17.4423 49.518 18.7246 48.789L40.5825 36.3375Z",
    fill: "url(#paint2_linear_2_163)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.5825 23.6655L18.7246 11.2155C17.4423 10.485 16.3036 10.5765 15.6153 11.3085L34.2637 30.003L40.5825 23.6655Z",
    fill: "url(#paint3_linear_2_163)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2_163",
    x: 14.9226,
    y: 10.7114,
    width: 34.5491,
    height: 38.5811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_163"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2_163",
    result: "effect2_innerShadow_2_163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2_163",
    x: 15.6153,
    y: 30.0015,
    width: 24.9672,
    height: 19.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_163",
    x1: 32.6205,
    y1: 13.0634,
    x2: 7.44753,
    y2: 38.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_163",
    x1: 50.6249,
    y1: 30.0015,
    x2: 14.4207,
    y2: 30.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_163",
    x1: 37.1502,
    y1: 33.4423,
    x2: 3.01254,
    y2: 67.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_163",
    x1: 10.9191,
    y1: 0.265179,
    x2: 26.1625,
    y2: 15.4709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGplayIcon);
export default __webpack_public_path__ + "static/media/gplay_icon.00a2871b01acb177506152518f2324a1.svg";
export { ForwardRef as ReactComponent };